import styled from 'styled-components'

const S = {}

S.HotspotLayout = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.column}, 1fr);
  gap: 16px;
  margin-bottom: 24px;
`

const HotspotLayout = ({ children, layout }) => {
  const getLayoutColumn = (placement) => {
		if (placement === '1-landscape' || placement === '1-square') return 1;
		else if (placement === '2-square') return 2;
	};

  return (
    <S.HotspotLayout column={getLayoutColumn(layout)}>
      {children}
    </S.HotspotLayout>
  )
}

export default HotspotLayout
